import { render } from "./Documents.vue?vue&type=template&id=6a861604&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"

import "./Documents.vue?vue&type=style&index=0&id=6a861604&scoped=true&lang=css"

import exportComponent from "/Users/home/Documents/kevin/ftd_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a861604"]])

export default __exports__